// Ticket Order Model
cv.Ticket = Backbone.RESTModel.extend({
  defaults: {
    first_name: "",
    last_name: "",
    email: "",
    description: "",
  },

  saveMap: {
    first_name: "first_name",
    last_name: "last_name",
    email: "email",
  },

  urlRoot: function () {
    return "/api/v2/tickets";
  },

  initialize: function () {
    console.log("Ticket model initialized.");
  },
});
Cocktail.mixin(cv.Ticket, cv.mixins.SyncModel);

// Tickets Collection
cv.Tickets = Backbone.Collection.extend({
  initialize: function () {
    console.log("Ticket collection initialized.");
  },

  url: function () {
    return "/api/v2/tickets?" + $.param(this.params);
  },

  model: cv.Donation,
});
Cocktail.mixin(cv.Tickets, cv.mixins.PaginateModel);
